import api from '../../../api';
import socketPromise from '../../../websocket';
import * as getNotifications from '../../../modules/notifications/actions/get';

function subscribe(dispatch, socket) {
    socket.emit('subscribe', 'S:Notification:main');

    socket.removeAllListeners('S:Notification:main');

    socket.on('S:Notification:main', () => {
        dispatch(getNotifications.request());
    });
}

export function request(dispatch) {
    api.get('/notifications', void 0, { cache: true })
        .then(data => dispatch(getNotifications.finish(data)))
        .catch(data => dispatch(getNotifications.error(data.errors)))
        .then(() => socketPromise)
        .then(socket => {
            subscribe(dispatch, socket);
            socket.on('auth', () => subscribe(dispatch, socket));
        });
}
